import { Component, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { startWith, switchMap, tap } from 'rxjs/operators';
import { MatInput } from '@angular/material/input';
import { Observable } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { debounce } from 'utils-decorators';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-form-autocomplete-type',
  templateUrl: './autocomplete-type.component.html',
  styleUrls: ['./autocomplete-type.component.scss'],
})
export class AutocompleteTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {

  @ViewChild(MatInput) formFieldControl: MatInput | undefined;
  @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger | undefined;

  filter: Observable<any[]> | any;

  myId: string = '';

  myOptions: any;

  override field: any;


  displayFn(item: any): string {
    return item && item.label ? item.label : '';
  }


  ngOnInit() {
    this.myOptions = this.field?.templateOptions?.myOption;
    this.myId = this.field?.templateOptions?.id;
    this.filter = this.formControl.valueChanges
      .pipe(tap((e) => {
        if (typeof e === 'string' && this.myOptions) {
          const str = e.toLowerCase();
          const res = this.myOptions.filter((item: any) => {
            const r = item?.name?.toLowerCase().indexOf(str) !== -1 ||
              item?.label?.toLowerCase().indexOf(str) !== -1;
            return r;
          });
          if (!res) {
            setTimeout(() => {
              this.formControl.setValue('');
              this.trigger?.openPanel();
            }, 100);
          }
        } else {
          this.focusNextElement();
        }
      }))
      .pipe(
        startWith(''),
        switchMap((term) => this.to['filter'](term)),
      );
  }

  dropAll($event:any): void {
    setTimeout(() => {
      this.formControl.setValue('');
      this.openPanel($event);
    }, 100);

  }


  @debounce(300)
  focusNextElement() {
    const id = +this.myId?.split('_')[1] + 1;
    const elem = document.getElementById(`my_${id}`);
    if (elem) {
      elem.focus();
    }
  }

  openPanel(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.trigger?.openPanel();
  }

  closePanel(event: any) {
    setTimeout(() => {
      event.stopPropagation();
      this.trigger?.closePanel();
    }, 100);
  }
}
